import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourLocalNorfolkAutoLocksmith from "./sections/YourLocalNorfolkAutoLocksmith";
import EmergencyRoadsideDispatch from "./sections/EmergencyRoadsideDispatch";
import ExpertKeySolutions from "./sections/ExpertKeySolutions";
import VehiclesWeSupport from "./sections/VehiclesWeSupport";
import RecentRoadsideRescues from "./sections/RecentRoadsideRescues";
import StartYourProtection from "./sections/StartYourProtection";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourLocalNorfolkAutoLocksmith />
      <EmergencyRoadsideDispatch />
      <ExpertKeySolutions />
      <VehiclesWeSupport />
      <RecentRoadsideRescues />
      <StartYourProtection />
      <Footer />
    </div>;
}